import { render } from "./NotFoundView.vue?vue&type=template&id=5f0e1298&scoped=true&ts=true"
import script from "./NotFoundView.vue?vue&type=script&lang=ts"
export * from "./NotFoundView.vue?vue&type=script&lang=ts"

import "./NotFoundView.vue?vue&type=style&index=0&id=5f0e1298&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\miauerka\\web-projects\\mimafi-project\\mimawebapp\\client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5f0e1298"]])

export default __exports__